/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentConnectorsDeleteAgentConnector } from "../../funcs/agentConnectorsDeleteAgentConnector.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteAgentConnectorRequest$inboundSchema,
};

export const tool$agentConnectorsDeleteAgentConnector: ToolDefinition<
  typeof args
> = {
  name: "agent-connectors-delete-agent-connector",
  description: `Delete a connector

Unregisters the connector-specific provider webhook and deletes the stored connector credentials. Telegram pending updates are dropped; WhatsApp deletion clears only the phone-number callback and does not unsubscribe other numbers in the business account.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentConnectorsDeleteAgentConnector(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
